
const env = {
  API_URL: process.env.REACT_APP_API_URL,
  API_ENV: process.env.REACT_APP_API_ENV,
  FACEBOOK_AUTH: process.env.REACT_APP_FACEBOOK_AUTH,
  GDriveURL: process.env.REACT_APP_GDRIVE_URL
};

export default env;
